import React from 'react';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import './About.css';
import InnerBanner from '../components/InnerBanner';
import serviceBg from '../assets/FFO+.jpeg';
import { SignalZero } from 'lucide-react';

const About = () => {

  const container = {
    hidden: { opacity: 0 },
    show: { opacity: 1, transition: { staggerChildren: 0.15 } }
  };

  const item = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0 }
  };

  return (
    <>
      <Helmet>
        <title>About Customersupports24x7 | Appliance Repair Bangalore</title>
        <meta
          name="description"
          content="Learn about Customersupports24x7, offering trusted appliance repair services across Bangalore for all major brands and home appliances."
        />
        <meta
          name="keywords"
          content="appliance repair services in Bangalore"
        />
        <meta property="og:title" content="About Customersupports24x7 | Appliance Repair Bangalore" />
        <meta
          property="og:description"
          content="Learn about Customersupports24x7, offering trusted appliance repair services across Bangalore for all major brands and home appliances."
        />
        <meta property="og:image" content="https://customersupports24x7.in/customerSupport.png" />
        <meta property="og:url" content="https://customersupports24x7.in/about" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="About Customersupports24x7 | Appliance Repair Bangalore" />
        <meta
          name="twitter:description"
          content="Learn about Customersupports24x7, offering trusted appliance repair services across Bangalore for all major brands and home appliances."
        />
        <meta name="twitter:image" content="https://customersupports24x7.in/customerSupport.png" />
        <link rel="canonical" href="https://customersupports24x7.in/about" />
      </Helmet>
    <div className="about-page-root">
      <InnerBanner title="About Us" bgImage={serviceBg} />

      <div className="dna-container">

        <div className="tech-grid-overlay"></div>

        {/* HERO */}
        <section className="dna-hero">
          <motion.div 
            className="vision-blob"
            animate={{ borderRadius: ["40% 60%", "60% 40%", "40% 60%"] }}
            transition={{ duration: 10, repeat: Infinity }}
          />

          <div className="dna-content">
            <span className="tech-label" style={{ fontSize: '20px' }}>Precision Service</span>

            <h2 className="dna-h2">
              Appliance Repair & 
              <span className="red-glow-text"> Service Near You</span>
            </h2>

            <p className="dna-p">
              We provide expert appliance repair with same-day doorstep support. 
              Our certified technicians ensure fast diagnosis and reliable service.
            </p>
          </div>
        </section>

        {/* GRID */}
        <motion.section
          className="skill-matrix"
          variants={container}
          initial="hidden"
          whileInView="show"
        >

          <motion.div className="matrix-item large-glass" variants={item}>
            <h3>Smart Diagnostics</h3>
            <p>
              Advanced tools to detect appliance issues quickly and accurately.
            </p>
          </motion.div>

          <motion.div className="matrix-item small-glass highlight-red" variants={item}>
            <div className="big-stat">98%</div>
            <p>First-Visit Fix Rate</p>
          </motion.div>

          <motion.div className="matrix-item small-glass" variants={item}>
            <h3>OEM Precision</h3>
            <p style={{ color: '#000000' }}>
              We use only original spare parts for long-lasting repairs.
            </p>
          </motion.div>

          <motion.div className="matrix-item wide-glass" variants={item}>
            <div className="matrix-flex">
              <div>
                <h3>Human-Centric Service</h3>
                <p style={{ color: '#000000' }}>Clean, professional, and on-time service.</p>
              </div>

              <div> <style jsx>{`
                .stat-pill {
                  display: inline-block;
                  background: rgba(255, 94, 58, 0.1);
                  color: #ff5e3a;
                  padding: 6px 12px;
                  border-radius: 12px;
                  font-size: 12px;
                  margin-top: 8px;
                }
              `}</style>
                <div className="stat-pill">2Hr Arrival</div>
                <div className="stat-pill">Clear Billing</div>
              </div>
            </div>
          </motion.div>

        </motion.section>

        {/* SHIELD */}
        <section className="shield-section">
          <div className="shield-card">
            <h3>90-Day Service Warranty</h3>
            <p style={{ color: '#fff' }}>Every repair is backed with a full guarantee.</p>
          </div>
        </section>

      </div>
    </div>    </>  );
};

export default About;
